module.exports = __webpack_public_path__ + "img/bell-ringing-white.9d442538.svg";